/*
 * 第3, 4 ,5章, 首页与第一个子阶段链接配置
 */

export const hackPaths = {
  "/six-trials-of-God-s-judgment-work/index":
    "/six-trials-of-God-s-judgment-work/the-trial-of-service-doers",
  "/God-incarnate-and-man-used-by-God/index":
    "/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate",
  "/spread-of-kingdom-gospel/index": "/spread-of-kingdom-gospel/1995-1999",
};

export const hackRoutes = {
  "six-trials-of-God-s-judgment-work": "the-trial-of-service-doers",
  "God-incarnate-and-man-used-by-God": "testifying-to-God-incarnate",
  "spread-of-kingdom-gospel": "1995-1999",
};
